import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_CATEGORY_PROFILE_QUERY = graphql(`
  query InternalAdminTagCategoryProfile($id: ID!) {
    internalAdminTagCategory(id: [$id]) {
      ...InternalAdminTagCategoryProfile
    }
  }
`);

export default INTERNAL_ADMIN_TAG_CATEGORY_PROFILE_QUERY;
